import { getAdcreativeTemplates, getAdCreativeTemplatesByID, getPromotedObject } from '@/api/tencent.model'
import { CREATIVE_TYPES } from './creative-const.js'
import { creativeElementsFilter } from './creative-form.js'

export const creativeMethods = {
  async getCreativeTemplates() {
    const { accounts, promoted_object_type, siteSet, wechat_position, wechatPostion } = this.planForm

    const data = await getAdcreativeTemplates({
      is_dynamic_creative: true,
      ad_account_id: accounts[0],
      promoted_object_type,
      wechat_scene_spec_position: wechat_position ? wechatPostion : [],
      site_set: siteSet
    })

    const creativeTypeIds = CREATIVE_TYPES.map((t) => t.value)

    // 根据已知创意形式列表，过滤重复和未接入创意形式
    const cates = {}
    data.forEach((tmp) => {
      const tmpId = tmp.adcreative_template_id
      if (creativeTypeIds.includes(tmpId)) {
        cates[tmpId] = tmp
      }
    })

    return Object.values(cates)
  },

  /**
   * @description: 根据创意形式id获取模板详情，并构建创意内容表单
   * @param {*} tmp
   */
  async getCreativeTemplateById(tmp) {
    try {
      const { accounts, siteSet, promoted_object_type, automatic_site_enabled } = this.planForm

      const params = {
        is_dynamic_creative: true,
        ad_account_id: accounts[0],
        promoted_object_type,
        adcreative_template_id: tmp.adcreative_template_id,
        automatic_site_enabled
      }

      if (!automatic_site_enabled) {
        params.site_set = siteSet
      }
      const data = await getAdCreativeTemplatesByID(params)
      const [tempJson] = data
      const { adcreative_elements, ...restInfo } = tempJson

      const { creativeFormModel, creativeTemplates } = await creativeElementsFilter.call(this, adcreative_elements)
      // console.log('creativeTemplates output: ', creativeTemplates)
      // console.log('creativeFormModel output: ', creativeFormModel)
      return {
        ...restInfo,
        creativeTemplates,
        creativeFormModel
      }
    } catch (e) {
      console.log('getAdCreativeTemplatesByID error output: ', e)
    }
  },

  /**
   * @description: 根据创意形式id获取模板详情，并构建创意内容表单
   * @param {*} tmp
   */
  async onCreativeTemplateChange(tmp) {
    this.templateDetailLoading = true

    this.getCreativeTemplateById(tmp).then((form) => {
      this.creativeForm = {
        ...this.creativeForm,
        ...form
      }
      this.templateDetailLoading = false
    })
  },

  getPromotedObjectList() {
    const { accounts } = this.planForm
    return getPromotedObject({ ad_account_id: accounts[0], promoted_object_type: 'PROMOTED_OBJECT_TYPE_WECHAT_CHANNELS' })
  },

  /**
   * @description: 选择素材确认后，更新creativeFormGroups
   * @return {*}
   */
  onCreativeAssetChange(newForm) {
    this.creativeForm = newForm
  }
}
